import { Grid } from '@mui/material';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { MouseEvent } from 'react';
import { ledColor } from 'utility';
import { CurrentStatusMessage } from './types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ErrorIcon from '@mui/icons-material/Error';

export default function StatusIndicator(props: { data: CurrentStatusMessage; setCurrentServiceName: Function }) {
  function statusPopup(e: MouseEvent<HTMLDivElement>) {
    props.setCurrentServiceName(props.data.Title);
  }

  const statusIcon = () => {
    if (props.data.Status.toLowerCase() === 'ok') {
      return <CheckCircleIcon color={ledColor(props.data.Status)} />;
    } else if (props.data.Status.toLowerCase() === 'degraded') {
      return <ErrorIcon color={ledColor(props.data.Status)} />;
    } else {
      return <CancelIcon color={ledColor(props.data.Status)} />;
    }
  };

  return (
    <Grid item xs={1} onClick={statusPopup}>
      <Box sx={{ display: 'flex' }}>
        <Chip icon={statusIcon()} label={props.data.Title} variant="outlined" />
      </Box>
    </Grid>
  );
}
